import React from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Input from "../../../../components/inputs/inputs";
import Button from "../../../../components/buttons/buttons";
import { Beat } from "../../../../plugins/spinners.plugin";
import { searchBusinessAction } from "../../../../redux/business/businessActions";
import businessType from "../../../../redux/business/businessTypes";
import { getABusiness } from "../../../../redux/business/businessActions";
import { transferRestaurantAction } from "../../../../redux/restaurant/restaurantActions";
import { transferStore } from "../../../../redux/stores/storeActions";

export default function TransferBusiness({
  selectedoutlet,
  outletType,
  selectedBusiness,
  setSelectedBusiness,
  businessName,
  setBusinessName,
  businessDetails,
  setBusinessDetails,
}) {
  const dispatch = useDispatch();

  const { search } = useSelector((state) => state.business);
  const { transferringRestaurant } = useSelector((state) => state.restaurant);
  const { transferringStore } = useSelector((state) => state.store);

  const handleSearch = (event) => {
    event.preventDefault();
    const { value } = event.target;
    setBusinessName(value);
    if (value.length >= 3) {
      dispatch(
        searchBusinessAction({
          search: value,
        })
      );
    } else if (value.length <= 3) {
      dispatch({ type: businessType["SEARCH_BUSINESS"], payLoad: [] });
      setBusinessDetails({});
      setSelectedBusiness({});
    }
  };

  function selectBusiness(result) {
    setSelectedBusiness(result);
    setBusinessName(result?.business_name);
    getSingleBusiness(result.id);
    var mydiv = document.getElementById(result.id);
    if (result.id) {
      mydiv.style.borderColor = "border-[#D14522]";
    }
    dispatch({ type: businessType["SEARCH_BUSINESS"], payLoad: [] });
  }

  const getSingleBusiness = async (id) => {
    try {
      const response = await dispatch(getABusiness(id));
      setBusinessDetails(response.data);
    } catch (error) {}
  };

  const handleTransferRestaurant = async () => {
    try {
      await dispatch(
        transferRestaurantAction({
          id: selectedoutlet?.id,
          business_id: selectedBusiness?.id,
        })
      );
    } catch (error) {}
  };

  const handleTransferStore = async () => {
    try {
      await dispatch(
        transferStore({
          id: selectedoutlet?.id,
          business_id: selectedBusiness?.id,
        })
      );
    } catch (error) {}
  };

  return (
    <>
      <div className="mx-auto bg-white dark:bg-[#121212] w-full p-6 ">
        <form>
          <div>
            <Input.Label
              title={"Search Business"}
              type="text"
              name="restaurant_id"
              id="restaurant_id"
              value={businessName}
              className="w-full border border-[#E4E4F3] bg-[#F3F3F3] focus:border-primary focus:ring-0 sm:text-sm"
              placeholder="Enter business name to search"
              onChange={handleSearch}
            />

            {search &&
              Array.isArray(search) &&
              search?.map((result, index) => (
                <div
                  className="p-3 border border-primary mb-2"
                  id={result.id}
                  key={index}
                  onClick={() => selectBusiness(result)}
                >
                  <div className=" grid-cols-3">
                    <div className="col-span-1">
                      <div className="">
                        <h6 className="text-sm font-meduim">
                          Name: {result.business_name}
                        </h6>
                      </div>
                    </div>
                    <div className="col-span-1">
                      <div>
                        <h6 className="text-sm font-meduim">
                          Phone: {result.business_phone}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </form>
        {/* Search Results */}
        <div>
          {businessName !== "" && selectedBusiness?.business_name && (
            <div className="border border-[#E4E4F3] dark:border-[#bcbcbc] bg-white dark:bg-[#121212] rounded-md py-5 px-4 sm:px-8">
              <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
                <h3 className="text-lg font-medium">Business Details</h3>
              </div>

              <div className="grid grid-cols-2 gap-4 sm:gap-8 mt-6">
                <div>
                  <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                    Business Name
                  </label>
                  <p className="text-[#151515] dark:text-white text-sm font-bold">
                    {selectedBusiness?.business_name}
                  </p>
                </div>
                <div>
                  <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                    Business Email
                  </label>
                  <p className="text-[#151515] dark:text-white text-sm font-bold break-words">
                    {selectedBusiness?.business_email}
                  </p>
                </div>
                <div>
                  <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                    Created On
                  </label>
                  <p className="text-[#151515] dark:text-white text-sm font-bold">
                    {moment(selectedBusiness?.created_at).format(
                      "Do, MMM YYYY, hh:mm a"
                    )}
                  </p>
                </div>
                <div>
                  <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                    Business ID
                  </label>
                  <p className="text-[#151515] dark:text-white text-sm font-bold">
                    {selectedBusiness?.id}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="mt-6">
          {businessName !== "" &&
            selectedBusiness?.business_name &&
            !search && (
              <div className="border border-[#E4E4F3] dark:border-[#bcbcbc] bg-white dark:bg-[#121212] rounded-md py-5 px-4 sm:px-8">
                <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
                  <h3 className="text-lg font-medium">
                    List of Restaurants and Store{" "}
                  </h3>
                </div>

                <div className="grid grid-cols-1 gap-3 mt-6">
                  {businessDetails?.restaurants?.length > 0 &&
                    businessDetails?.restaurants?.map((restaurant) => (
                      <div key={restaurant.id} className="flex justify-between">
                        <span className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                          {restaurant?.restaurant_name}
                        </span>
                        <span className="text-[#151515] dark:text-white text-sm font-bold">
                          {restaurant?.restaurant_city}
                        </span>
                      </div>
                    ))}

                  {businessDetails?.stores?.length > 0 &&
                    businessDetails?.stores?.map((store) => (
                      <div key={store.id} className="flex justify-between">
                        <span className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                          {store?.store_name}
                        </span>
                        <p className="text-[#151515] dark:text-white text-sm font-bold">
                          {store?.store_city}
                        </p>
                      </div>
                    ))}
                </div>
              </div>
            )}
        </div>
      </div>
      {/* Transfer Ownership buttons for store and restaurant for web view */}
      <div className="hidden sm:flex justify-center mt-6">
        {businessName !== "" &&
          selectedBusiness?.business_name &&
          !search &&
          outletType === "restaurant" && (
            <Button.Primary
              type={"button"}
              disabled={transferringRestaurant}
              onClick={() => handleTransferRestaurant()}
              title={transferringRestaurant ? <Beat /> : "Transfer Ownership"}
            />
          )}
        {businessName !== "" &&
          selectedBusiness?.business_name &&
          !search &&
          outletType === "store" && (
            <Button.Primary
              type={"button"}
              disabled={transferringStore}
              onClick={() => handleTransferStore()}
              title={transferringStore ? <Beat /> : "Transfer Ownership"}
            />
          )}
      </div>
    </>
  );
}
